/** * * Asynchronously loads the component for
IMEICheck
* */ import { lazyLoad } from "utils/loadable";
export const IMEICheck = lazyLoad(
  () => import("./index"),
  (module) => module.IMEICheck
);
